module.exports = __webpack_public_path__ + "static/dagger-mtg_afr-0d06ed0c61a29f3f7490fb2e8aa377d6.jpg";